import ChipsAutocomplete from '@superfunnel/ui-core/ChipsAutocomplete';
import { classNames } from '@superfunnel/utils';
import { useMemo, useState } from 'react';
import { uid } from 'uid';

interface Chip {
  id: string;
  title: string;
}

interface Props {
  title?: string;
  selected: Chip[];
  setSelected?: (selected: Chip[]) => void;
  filterQuery?: (query: string) => string;
  options: Chip[];
  className?: string;
}

export default function SettingChipsField({
  title,
  selected,
  setSelected,
  filterQuery,
  options,
  className,
}: Props) {
  const [query, setQuery] = useState('');

  const allOptions = useMemo(() => {
    const cleanQuery = query.trim();

    const optionsAndSelected = [
      ...selected.filter((s) => !options.some((o) => o.id === s.id)),
      ...options,
    ];

    if (cleanQuery) {
      return [
        ...(optionsAndSelected.every(
          (o) => o.title.toLowerCase() !== cleanQuery.toLowerCase(),
        )
          ? [{ id: uid(8), title: cleanQuery }]
          : []),
        ...optionsAndSelected.filter((o) =>
          o.title.toLowerCase().includes(cleanQuery.toLowerCase()),
        ),
      ];
    }

    return optionsAndSelected;
  }, [options, query, selected]);

  return (
    <div
      className={classNames(
        'font-inter grid w-full items-center gap-1',
        className,
      )}
    >
      <p className="text-base-700 flex items-center gap-2 text-sm font-medium">
        {title}
      </p>
      <div className="flex flex-wrap items-start justify-between">
        <ChipsAutocomplete<Chip>
          className={'[&>div]:rounded-2lg'}
          getValue={(c) => c?.title}
          selected={selected}
          onChange={(s) => {
            setSelected?.(s);
          }}
          onInputChange={(t) => setQuery(t)}
          getOptionId={(t) => t.id}
          options={allOptions}
          filterQuery={filterQuery}
        />
      </div>
    </div>
  );
}
